import React, { useState } from "react";
import { AudioTrimInputs } from "./AudioTrimInputs";
import { useSaveAudioTrim } from "./hooks/useSaveAudioTrim";
import { formatTimestamp } from "./formatTimestamp";
import { parseTimestamp } from "./parseTimestamp";

interface AudioTrimContainerProps {
    ceremonyId: number;
    musicId: number;
    audioRef: React.RefObject<HTMLAudioElement>;
    onSuccess?: (data) => void;
}

export function AudioTrimContainer({
    ceremonyId,
    musicId,
    audioRef,
    onSuccess,
}: AudioTrimContainerProps) {
    const [start, setStart] = useState("00:00.000");
    const [end, setEnd] = useState("00:00.000");
    const { handleSaveTrim, isLoading } = useSaveAudioTrim(
        ceremonyId,
        musicId,
        onSuccess
    );

    React.useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;
        setEnd(formatTimestamp(audio.duration * 1000));
    }, [audioRef]);

    // Set start/end to formatted time.
    const markStart = () => setStart(formatTimestamp(audioRef.current.currentTime * 1000));
    const markEnd = () => setEnd(formatTimestamp(audioRef.current.currentTime * 1000));

    // On save, convert to ms
    const handleSave = () => {
        handleSaveTrim(parseTimestamp(start), parseTimestamp(end));
    };

    return (
        <AudioTrimInputs
            start={start}
            end={end}
            onSave={handleSave}
            isLoading={isLoading}
            markStart={markStart}
            markEnd={markEnd}
        />
    );
}
